import { DisciplinePage } from '../../../../shared/components/DisciplinePage';
import { PlaceholderPanel } from '../../../../shared/components/PlaceholderPanel';
import { AuditoriaPage } from '../../../compliance/pages/AuditoriaPage';
import { DashboardsPanel } from './DashboardsPanel';
import { useI18n } from '../../../../../i18n';

export function InformationPage() {
  const { t } = useI18n();
  return (
    <DisciplinePage
      accentColor="#0E243E"
      disciplineKey="information"
      disciplineTitle={t.sidebar.pageTitle.information}
      tabs={[
        {
          key: 'search',
          label: t.information.tabs.search,
          component: <PlaceholderPanel title={t.information.tabs.search} />,
        },
        { key: 'audit', label: t.information.tabs.audit, component: <AuditoriaPage embedded /> },
        { key: 'dashboards', label: t.information.tabs.dashboards, component: <DashboardsPanel /> },
      ]}
    />
  );
}
